import { styled } from "styled-components"
import { COLOR } from "utils/color"

export const CarrierIdChip = styled.div`
  display: flex;
  background-color: ${COLOR.WHITE_SMOKE};
  align-items: center;
  cursor: pointer;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 15px;
`

export const CarrierIdText = styled.span`
  text-align: center;
  color: ${COLOR.GREY};
  font-weight: 500;
  font-size: 10px;
`

export const CarriersExternalIdsContainer = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 15px;
`
